import { render, staticRenderFns } from "./LayoutAuthenticated.vue?vue&type=template&id=a04702e4"
import script from "./LayoutAuthenticated.vue?vue&type=script&lang=js"
export * from "./LayoutAuthenticated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports